import { render, staticRenderFns } from "./ReversiorAttr.vue?vue&type=template&id=78f987df&scoped=true&"
import script from "./ReversiorAttr.vue?vue&type=script&lang=js&"
export * from "./ReversiorAttr.vue?vue&type=script&lang=js&"
import style0 from "./ReversiorAttr.vue?vue&type=style&index=0&id=78f987df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.8_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f987df",
  null
  
)

export default component.exports